import React from "react";
import classNames from "classnames";
import styles from "./fix-button.module.scss";
import { Button } from "@headlessui/react";

export interface FixButtonProps {
  variant?: "default" | "primary" | "neutral" | "text" | "more";
  disabled?: boolean;
  size?: "default" | "small" | "medium" | "large";
  href?: string;
  target?: string;
  type?: "button" | "submit" | "reset";
  loading?: boolean;
  fullWidth?: boolean;
  children?: React.ReactNode;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  className?: string;
  labelClassName?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

export const FixButton: React.FC<FixButtonProps> = ({
  variant = "default",
  disabled = false,
  size = "default",
  href,
  target,
  type = "button",
  loading = false,
  fullWidth = false,
  children,
  prefix,
  suffix,
  className,
  labelClassName,
  onClick,
  ...rest
}) => {
  const classes = classNames(
    styles.button,
    styles[`variant_${variant}`],
    styles[`size_${size}`],
    {
      [styles.fullWidth]: fullWidth,
      [styles.disabled]: disabled || loading,
    },
    className,
  );

  const content = (
    <>
      {prefix && <span className={styles.prefix}>{prefix}</span>}
      <span className={classNames(styles.buttonLabel, labelClassName)}>{children}</span>
      {suffix && <span className={styles.suffix}>{suffix}</span>}
    </>
  );

  if (href) {
    return (
      <a href={href} target={target} onClick={onClick} className={classes} {...rest}>
        {content}
      </a>
    );
  }

  return (
    <Button type={type} onClick={onClick} className={classes} disabled={disabled || loading} {...rest}>
      {content}
    </Button>
  );
};
